import gql from 'not-graphql-tag';

const AccountWithPremiseInfoFragment = gql`
  fragment AccountWithPremiseInfo on AccountDetail {
    isDefault
    accountNumber
    encryptedAccountNumber
    encryptedPersonId
    description
    mainCustomerName
    isActive
    premiseInfo {
      encryptedPremiseId
      addressLine1
      addressLine2
      houseType
      city
      county
      state
      postal
      country
      saDetails {
        encryptedSAId
        saStatus
        startDate
        endDate
        nickName
      }
    }
  }
`;

export const getClosedAccountsList = gql`
  query getClosedAccountsList($params: AccountDetailListParams!) {
    getAccountDetailList(params: $params) {
      totalCount
      accounts {
        ...AccountWithPremiseInfo
      }
    }
  }
  ${AccountWithPremiseInfoFragment}
`;

export const getAccountDetails = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
  ) {
    getAccountDetails(params: $params) {
      accountNumber
      encryptedAccountNumber
      encryptedPersonId
      description
      isDefault
      mainCustomerName
      serviceAddresses {
        addressLine1
      }
      billInfo {
        amountDue
      }      
    }
  }
`;
